const Blog = () => {
    return (
        <div>
            <h1>Under Construction</h1>

        </div>
    )
}

export default Blog;